import { render, staticRenderFns } from "./activate-account.vue?vue&type=template&id=100e3530&scoped=true";
import script from "./activate-account.vue?vue&type=script&lang=js";
export * from "./activate-account.vue?vue&type=script&lang=js";
import style0 from "./activate-account.vue?vue&type=style&index=0&id=100e3530&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "100e3530", null);
export default component.exports;